module.exports = __webpack_public_path__ + "img/violet_085.7323f714.png";